import { render, staticRenderFns } from "./SelectedFile.vue?vue&type=template&id=d62a81e2&scoped=true&"
import script from "./SelectedFile.vue?vue&type=script&lang=js&"
export * from "./SelectedFile.vue?vue&type=script&lang=js&"
import style0 from "./SelectedFile.vue?vue&type=style&index=0&id=d62a81e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62a81e2",
  null
  
)

export default component.exports